var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "65px",
    viewBox: "0 0 90 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "landing-page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing_final",
    transform: "translate(-384.000000, -6696.000000)",
    fillRule: "nonzero",
    stroke: "#26F4BD",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "testimonials",
    transform: "translate(111.000000, 6423.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.647799,306.439425 C296.886792,306.188912 296.383648,304.435318 296.886792,303.182752 C299.402516,296.669405 305.943396,288.652977 313.490566,282.89117 C315.503145,281.38809 315.503145,278.632444 313.490566,277.379877 L311.72956,276.12731 C309.213836,274.62423 305.943396,274.62423 303.427673,276.12731 C292.610063,282.89117 275.251572,298.172485 275,315.457906 C275,327.983573 282.295597,336 293.616352,336 C304.433962,336 311.226415,328.234086 311.226415,319.967146 C311.226415,313.453799 306.194969,307.942505 298.647799,306.439425 Z M344.647799,306.439425 C342.886792,306.188912 342.383648,304.435318 342.886792,303.182752 C345.402516,296.669405 351.943396,288.652977 359.490566,282.89117 C361.503145,281.38809 361.503145,278.632444 359.490566,277.379877 L357.981132,276.12731 C355.465409,274.62423 352.194969,274.62423 349.679245,276.12731 C338.861635,282.89117 321.251572,298.172485 321,315.457906 C321,327.983573 328.295597,336 339.616352,336 C350.433962,336 357.226415,328.234086 357.226415,319.967146 C357.226415,313.453799 352.194969,307.942505 344.647799,306.439425 Z",
    id: "Shape-Copy"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.d01441bc9d4193188f6343a35b6c0a80.svg";
export { ForwardRef as ReactComponent };